if (!customElements.get('newsletter-popup')) {
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey;
      this.subscribedKey = this.dataset.subscribedKey;
      this.delay = Number(this.dataset.delay) || 3000;
      this.closeButtons = this.querySelectorAll('[data-popup-close]');
      this.hasFormError = Boolean(this.querySelector('[data-newsletter-popup-error]'));
      this.hasSuccessfulSubscription = Boolean(this.querySelector('[data-newsletter-popup-success]'));
      this.onEscape = this.onEscape.bind(this);

      this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));

      if (this.hasSuccessfulSubscription) {
        this.saveSubscription();
        this.close();
        return;
      }

      if (this.isSubscribed()) return;

      if (this.hasFormError) {
        this.open();
        return;
      }

      if (this.wasShownRecently()) return;

      this.timer = window.setTimeout(() => {
        this.open();
        this.saveShownTime();
      }, this.delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('keyup', this.onEscape);
      document.body.classList.remove('newsletter-popup-open');
    }

    wasShownRecently() {
      try {
        const lastShown = Number(window.localStorage.getItem(this.storageKey));
        return Number.isFinite(lastShown) && Date.now() - lastShown < 86400000;
      } catch (error) {
        return false;
      }
    }

    saveShownTime() {
      try {
        window.localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (error) {
        // The popup remains functional when storage is unavailable.
      }
    }

    isSubscribed() {
      try {
        return window.localStorage.getItem(this.subscribedKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    saveSubscription() {
      try {
        window.localStorage.setItem(this.subscribedKey, 'true');
      } catch (error) {
        // The popup remains functional when storage is unavailable.
      }
    }

    open() {
      this.hidden = false;
      document.body.classList.add('newsletter-popup-open');
      document.addEventListener('keyup', this.onEscape);
      requestAnimationFrame(() => this.setAttribute('open', ''));
    }

    close() {
      window.clearTimeout(this.timer);
      this.removeAttribute('open');
      this.hidden = true;
      document.body.classList.remove('newsletter-popup-open');
      document.removeEventListener('keyup', this.onEscape);
    }

    onEscape(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('newsletter-popup', NewsletterPopup);
}
